/**
 * Hr api spec
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Duration of the appointment
 */
export interface ReadAppointmentDtoDuration { 
    value?: number;
    unit?: ReadAppointmentDtoDuration.UnitEnum;
}
export namespace ReadAppointmentDtoDuration {
    export const UnitEnum = {
        Minutes: 'minutes',
        Hours: 'hours',
        Days: 'days'
    } as const;
    export type UnitEnum = typeof UnitEnum[keyof typeof UnitEnum];
}


